// ホスト名 → SiteInfoId。閉鎖店（IsClosed=1）は載せない。
// 店が増えたらここに1行足して deploy するだけでよい（店側の共通部は触らない）。
const HOSTS: Record<string, number> = {
  'www.fukuro.in': 1,
  'www.anshinya.com': 2,
  'www.opp-honpo.net': 3,
  'www.dansai.jp': 4,
  'www.pack-japan.jp': 6,
  'www.paper-straw.jp': 9,
  'www.b-futou.com': 10,
  'www.comic-samurai.com': 11,
  'www.kirakirapunpun-maru.com': 14,
  'www.button-mart.com': 15,
  'www.lustia.net': 16,
}

/**
 * hostname から SiteInfoId を引く。表に無ければ ?wu_site= での上書きを見る
 * （devserver・検証台などホスト名表に載らない環境のための逃げ道。本番ホストでは
 * 表が先に当たるので ?wu_site= を付けても上書きされない）。
 */
export function getSiteInfoId(
  hostname: string = typeof location === 'undefined' ? '' : location.hostname,
): number | null {
  return HOSTS[hostname] ?? devOverride() ?? null
}

function devOverride(): number | null {
  if (typeof location === 'undefined') return null
  const raw = new URLSearchParams(location.search).get('wu_site')
  if (!raw) return null
  const n = Number(raw)
  return Number.isInteger(n) && n > 0 ? n : null
}
